/**
 * Initializes scroll veil functionality on a given container element.
 * The scroll veil adds visual cues to indicate users of scrollable content
 * @param {HTMLElement} container
 * @returns
 */
export const initScrollVeil = (container) => {
  if (!container) {
    return;
  }

  if (container.dataset.scrollVeilInit) {
    return;
  }

  container.dataset.scrollVeilInit = "true";

  const updateVeil = () => {
    const isScrollable = container.scrollHeight > container.clientHeight;
    const atBottom =
      container.scrollHeight - container.scrollTop <=
      container.clientHeight + 2;

    container.classList.toggle("has-scroll", isScrollable);
    container.classList.toggle("is-scrolled-to-bottom", atBottom);
  };

  requestAnimationFrame(updateVeil);
  container.addEventListener("scroll", updateVeil, { passive: true });
};
